export const ESTILOS_LISTA_CAPAS = `
& ul {
    list-style: none;
    padding: 0px;
    margin: 0px;
    margin-left: 30px;
}

& ul li {
    padding: 4px 8px;
}

& ul li label {
    cursor: pointer;
}

& a {
    text-decoration: none;
}

& ul li > .fas {
    font-size: 11px;
    color: #4a4242;
    margin-left: 10px;
}

& .grupo-capa-titulo {
    color: black;
    font-weight: 600;
}

& .p-contextmenu a {
    text-decoration: none!important;
}

& .capaResaltada {
    color: #9235cb !important;
    font-weight: 600;
}
`;